import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_1: FaireProductEntity = {
  token: "legacy_prod_abbott-1",
  type: "product",
  name: "Green LED Pillar Candle 2x4 H",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/83b3516d018619cae0dce6c6423e0118383497e60344092baa6a182121210bd0.jpeg",
  priceDollars: 8,
  msrpDollars: 16,
  isBestseller: true,
  subcategory: "Pillar Candles",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_candles-holders"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
